












import Vue from 'vue';
import attributoEdit from '@/components/commands/AttributoEdit.vue';

export default Vue.extend({
    components: { attributoEdit },
    methods: {
        close(tipo: string) {
            this.$router.push({
                name: 'AttributoList',
                params: { tipo: tipo },
            });
        },
    },
});
